import validate from "C:/sb/workspace/sbform/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  auth: () => import("C:/sb/workspace/sbform/src/middleware/auth.ts"),
  brand: () => import("C:/sb/workspace/sbform/src/middleware/brand.ts")
}